import {
  roomStageIdsMap,
  roomStepIdsMap,
} from '../../../../constants/room/lifeCycle';

export const resultCodesMap = {
  success: 0,
  blocked: 1,
  busy: 2,
  datePassed: 3,
  roomRegistered: 4,
  roomUnavailable: 5,
  beforeIndividualDate: 6,
  unknownError: -1,

  updateRecord: { hasResult: 1 },
};

export const registrationStage = roomStageIdsMap.acceptance;

export const registrationSteps = new Set([
  roomStepIdsMap.readyForAcceptance,
  roomStepIdsMap.invite,
  roomStepIdsMap.ownerNotCome,
]);

export const stateTypes = {
  registerAvailability: 'registerAvailability',
  address: 'address',
  owners: 'owners',
  selectedOwner: 'selectedOwner',
  addressesAndClient: 'addressesAndClient',
  save: 'save',
};

export const controllerEventsEnum = {
  REGISTRATION_FROM_ROOM: 'registrationFromRoom',
  reREGISTRATION_FROM_CALENDAR: 'reRegistrationFromCalendar',
  reREGISTRATION_FROM_ROOM: 'reRegistrationFromRoom',
  SELECT_REGISTRATION_INTERVAL: 'selectRegistrationInterval',
  UPDATE_REGISTRATION_FROM_ROOM: 'updateRegistrationFromRoom',
  UPDATE_REGISTRATION_FROM_CALENDAR: 'updateRegistrationFromCalendar',
};

export const controllerModes = {
  idle: 'idle',
  registrationFromRoom: 'registrationFromRoom',
  reRegistrationFromCalendar: 'reRegistrationFromCalendar',
  reRegistrationFromRoom: 'reRegistrationFromRoom',
  updateRegistration: 'updateRegistration',
};

export const toListModes = [
  controllerModes.reRegistrationFromRoom,
  controllerModes.registrationFromRoom,
];
